import api from '../index'

export interface OrderListParams {
  page?: number
  pageSize?: number
  keyword?: string
  pay_status?: number
  order_type?: number
}

export default {
  // 获取订单列表
  list: (params?: OrderListParams) => api.get('order/list', { params }),

  // 获取订单详情
  show: (id: number) => api.get(`order/show/${id}`),
}
